var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-wrapper"},[_c('CustomSelect',{attrs:{"options":_vm.navigationOptions,"default":_vm.getCurrentRouteName(),"placeholder":"Select section","custom-class":"navigation-select"},on:{"selected":_vm.navigateTo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }